import "./About.css";

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        
        {/* Left: Images */}
        <div className="about-images">
          <img
            src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
            alt="Modular Kitchen"
            className="img-large"
          />
          <div className="img-grid">
            <img
              src="https://images.unsplash.com/photo-1618220179428-22790b461013"
              alt="Wardrobe Design"
            />
            <img
              src="https://images.unsplash.com/photo-1743435009576-1beabc1043bd?q=80&w=2326&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="TV Unit Design"
            />
          </div>
        </div>

        {/* Right: Content */}
        <div className="about-text">
          <h2>Complete Home Interior Solutions</h2>

          <p>
            We provide end-to-end interior solutions designed to transform
            your house into a thoughtfully crafted home.
          </p>

          <p>
            From premium <strong>modular kitchens</strong> and
            <strong> next-generation wardrobes</strong> to elegant
            <strong> TV unit designs</strong> and smart storage solutions,
            we take care of everything — design, execution, and finish.
          </p>

          <ul className="about-list">
            <li>✔ Modular Kitchens</li>
            <li>✔ Designer Wardrobes</li>
            <li>✔ TV Units & Living Spaces</li>
            <li>✔ Complete Home Interiors</li>
          </ul>

          <p className="highlight">
            One partner for your entire home interior journey.
          </p>
        </div>
      </div>
    </section>
  );
}

export { About };